import { useContext } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

const useRouterBasename = () => {
  //
  // useHref is a more supported way to do this, but that throws errors if you're not in a router
  //
  const navigation = useContext(UNSAFE_NavigationContext);

  return navigation?.basename;
};

export default useRouterBasename;
